export const RmBudgetColumns=[
    "Month",
    "Year",
    "ProcurementManager",
    "Count",
    "Quantity"
]